import axios from "../axiosConfig";
import * as constants from "../../constant.module.json";
import { currentLanguage } from "../../algorithms/storage";
import {
  handleCatchErrors,
  responseDataFormat,
} from "../middlewares/resolveRequests";

export const loadLookups = async (id, token) => {
  let data;
  try {
    data = await axios.get(`Lookup/Get?Type=${id}`, {
      headers: {
        "Accept-Language": currentLanguage(),
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (e) {
    data = handleCatchErrors(e);
  } finally {
    return responseDataFormat(data);
  }
};

export const loadSectors = async (token) => {
  let data;
  try {
    data = await axios.get(`Community/GetCommunityForm`, {
      headers: {
        "Accept-Language": currentLanguage(),
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (e) {
    data = handleCatchErrors(e);
  } finally {
    return responseDataFormat(data);
  }
};

export const loadCommunitiesWithSectors = async (id, token) => {
  let data;
  try {
    data = await axios.get(`Community/GetCommunityWithSector/${id}`, {
      headers: {
        "Accept-Language": currentLanguage(),
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (e) {
    data = handleCatchErrors(e);
  } finally {
    return responseDataFormat(data);
  }
};

export const applicantLookups = async () => {
  let data;
  try {
    data = await axios.get(
      `Applicant/RegisterApplicant/${constants.clientId}`,
      {
        headers: {
          "Accept-Language": currentLanguage(),
        },
      }
    );
  } catch (e) {
    data = handleCatchErrors(e);
  } finally {
    return responseDataFormat(data);
  }
};

export const getAllLookupsNames = async () => {
  let data;
  try {
    data = await axios.get(`Lookup/GetLookupsNames`, {
      headers: {
        "Accept-Language": currentLanguage(),
      },
    });
  } catch (e) {
    data = handleCatchErrors(e);
  } finally {
    return responseDataFormat(data);
  }
};
export const getAllLookupByName = async (name) => {
  let data;
  try {
    data = await axios.get(`Lookup/GetLookupsData/${name}`, {
      headers: {
        "Accept-Language": currentLanguage(),
      },
    });
  } catch (e) {
    data = handleCatchErrors(e);
  } finally {
    return responseDataFormat(data);
  }
};

export const deleteLookup = async (id, name) => {
  let data;
  try {
    data = await axios.post(
      `Lookup/DeleteLookupsData?LookupName=${name}&Id=${id}`,
      {
        headers: {
          "Accept-Language": currentLanguage(),
        },
      }
    );
  } catch (e) {
    data = handleCatchErrors(e);
  } finally {
    return responseDataFormat(data);
  }
};

export const addLookup = async (bodyData, userToken) => {
  let data;
  try {
    data = await axios.post(`Lookup/AddLookupsData`, bodyData, {
      headers: {
        Authorization: `Bearer ${userToken}`,
        "Accept-Language": currentLanguage(),
      },
    });
  } catch (e) {
    data = handleCatchErrors(e);
  } finally {
    return responseDataFormat(data);
  }
};
export const editLookup = async (bodyData, userToken) => {
  let data;
  try {
    data = await axios.post(`Lookup/EditLookupsData`, bodyData, {
      headers: {
        Authorization: `Bearer ${userToken}`,
        "Accept-Language": currentLanguage(),
      },
    });
  } catch (e) {
    data = handleCatchErrors(e);
  } finally {
    return responseDataFormat(data);
  }
};
